// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 10V22H19V12L5 12L5 22H3L3 10L21 10ZM21 2V8L3 8L3 2L21 2Z"}}]};

const PageHeadFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'page-head-filled',
    ref,
    icon: element,
  },
));

PageHeadFilledIcon.displayName = 'PageHeadFilledIcon';

export default PageHeadFilledIcon;
